import React from 'react'
import './index.less'
import cx from 'classnames'
import { Carousel, WingBlank } from 'antd-mobile'
import { goIndex } from '@/assets/js/utils'

class Notice extends React.Component {
    constructor () {
        super()
        this.state = {
            isShow: true
        }
    }

    handleData = (title) => {
        if (title) {
            if (title.length > 23) {
                return title.slice(0, 23) + '...'
            } else {
                return title
            }
        }
    }

    render () {
        const { isShow } = this.state
        const {
            buriedPointEvent,
            data: { position, trackId, sublist = [], style = {}, titleImageUrl }
        } = this.props
        const {
            backgroundColor,
            backgroundPicUrl
        } = style
        return (
            <div
                className={cx('noticeContainer', !isShow ? 'noticeContainerNone' : null)}
                style={{
                    backgroundColor: backgroundColor || '',
                    backgroundImage: backgroundPicUrl ? `url(${backgroundPicUrl})` : ''
                }}
            >
                <div
                    className={'noticeIcon'}
                    style={{
                        backgroundImage: titleImageUrl ? `url(${titleImageUrl})` : '',
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: '100%'
                    }}
                ></div>
                <div className={'noticeContentContainer'}>
                    <WingBlank className='my-wingBlank'>
                        <Carousel
                            className="my-carousel"
                            vertical
                            dots={false}
                            dragging={false}
                            swiping={false}
                            autoplay
                            infinite
                        >
                            {
                                sublist.map((item, index) => {
                                    return (
                                        <div
                                            className={'v-item statistics-dom'}
                                            key={index}
                                            onClick={() => {
                                                buriedPointEvent({
                                                    button_name: `${trackId}`,
                                                    button_id: `${item.id}`,
                                                    button_order: `${index + 1}`,
                                                    area_order: position,
                                                    button_area: `${position}-${trackId}`
                                                })
                                                goIndex(item.url, trackId, item.keyword, item)
                                            }}
                                        >
                                            {this.handleData(item.title)}
                                        </div>
                                    )
                                })
                            }
                        </Carousel>
                    </WingBlank>
                </div>
                <div
                    className={'noticeCloseIcon'}
                    onClick={() => {
                        this.setState({ isShow: !this.state.isShow })
                    }}
                ></div>
            </div>
        )
    }
}

export default Notice
